export const dedupeProductsById = (products = []) => {
  if (!Array.isArray(products)) return [];

  const seenIds = new Set();
  return products.filter((product) => {
    const rawId = product?.id ?? product?.productid ?? product?.product_id;
    const id = Number(rawId);
    if (!Number.isFinite(id)) return true;
    if (seenIds.has(id)) return false;
    seenIds.add(id);
    return true;
  });
};

export const mapWithConcurrency = async (items = [], worker, limit = 5) => {
  const list = Array.isArray(items) ? items : [];
  const results = new Array(list.length);
  let nextIndex = 0;
  const workerCount = Math.min(Math.max(1, Number(limit) || 1), list.length);

  await Promise.all(
    Array.from({ length: workerCount }, async () => {
      while (nextIndex < list.length) {
        const index = nextIndex;
        nextIndex += 1;
        results[index] = await worker(list[index], index);
      }
    })
  );
  return results;
};
